export default "__VITE_ASSET__f827ba67__"